import React from 'react'
import MovieSearchTextDisplay from './MovieSearchTextDisplay'

const MovieSearchLinkWithoutRouter =({
    programOverviewUrl,
    searchLinkClass='',
    iconThin,
    translation
}) => (
    <a 
        className={"search-link" + (searchLinkClass ? ' ' + searchLinkClass : '')}
        href={programOverviewUrl + '?searchopen=1'}
    >
        <MovieSearchTextDisplay
            iconThin={iconThin}
            translation={translation}
        />
    </a>
)

export default MovieSearchLinkWithoutRouter